import clsx from 'clsx'

export interface SpacerProps {
  /**
   * Optional class name
   */
  className?: string
}

export default function Spacer({ className }: SpacerProps) {
  return <div className={clsx('h-8 md:h-12 lg:h-16', className)}></div>
}
